var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row h-100 flex-center"},[_c('form-progress',{attrs:{"show":true}}),_vm._v(" "),_c('div',{staticClass:"col-lg-9 pt-0 px-6 px-md-0 pb-4"},[_vm._t("before"),_vm._v(" "),_c('form-layout')],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }